/* eslint-disable no-underscore-dangle */
/* eslint-disable prefer-destructuring */
/* eslint-disable import/no-cycle */
/* eslint-disable no-undef */

import { axiosIns } from '@/libs/axios'
import { getItem, setItem } from '@/@core/utils/storage-utils'
import FetchUserError from '@/@core//classes/FetchUserError'

// This is a store for authentication module
export default {
  namespaced: true,
  state: {
    userData: {
      id: null,
      name: null,
      email: null,
      phoneNumber: null,
      kitUsers: [],
    },
    contextKitUserId: null,
    contextBarcodeId: null,
    jwtToken: null,
  },
  getters: {
    GET_USER: state => state.userData,
    GET_JWT_TOKEN: state => state.token,
    GET_CONTEXT_KIT_USER_ID: state => state.contextKitUserId,
    GET_CONTEXT_BARCODE_ID: state => state.contextBarcodeId,
    GET_CONTEXT_KIT_USER: state => {
      if (state.userData.kitUsers.length === 0) return null
      const filteredContextKitUsers = state.userData.kitUsers.filter(
        kitUser => kitUser._id === state.contextKitUserId,
      )
      if (filteredContextKitUsers.length === 0) return null
      return filteredContextKitUsers[0]
    },
    GET_CONTEXT_BARCODE: (state, getters) => {
      const contextKitUser = getters.GET_CONTEXT_KIT_USER
      if (!contextKitUser) return null
      const filteredBarcodes = contextKitUser.barcodes.filter(
        barcode => barcode._id === state.contextBarcodeId,
      )
      if (filteredBarcodes.length === 0) return null
      return filteredBarcodes[0]
    },
  },
  mutations: {
    // -------------------
    // sets user data after fetch
    //--------------------
    SET_USER: (state, payload) => {
      setItem('userData', JSON.stringify(payload))
      state.userData = payload
      const contextKitUserId = sessionStorage.getItem('contextKitUserId')
      const contextBarcodeId = sessionStorage.getItem('contextBarcodeId')
      if (payload.kitUsers && payload.kitUsers.length > 0) {
        if (
          typeof contextBarcodeId
          && contextBarcodeId !== null
          && contextBarcodeId !== ''
        ) {
          state.contextKitUserId = contextKitUserId
        } else {
          state.contextKitUserId = payload.kitUsers[0]._id
          sessionStorage.setItem('contextKitUserId', payload.kitUsers[0]._id)
        }
        if (
          payload.kitUsers[0].barcodes
          && payload.kitUsers[0].barcodes.length > 0
        ) {
          if (
            typeof contextKitUserId
            && contextKitUserId !== null
            && contextKitUserId !== ''
          ) {
            state.contextBarcodeId = contextBarcodeId
          } else {
            state.contextBarcodeId = payload.kitUsers[0].barcodes[0]._id
            sessionStorage.setItem(
              'contextBarcodeId',
              payload.kitUsers[0].barcodes[0]._id,
            )
          }
        }
      }
    },
    // -------------------
    // change the context of the barcode and fetch the corresponding kit user id
    //--------------------
    CHANGE_CONTEXT_BARCODE: (state, payload) => {
      state.contextBarcodeId = payload
      sessionStorage.setItem('contextBarcodeId', payload)
      // Given a barcode, finding the corresponding kit user id
      state.userData.kitUsers.forEach(user => {
        user.barcodes.forEach(barcode => {
          if (barcode._id === payload) {
            state.contextKitUserId = user._id
            sessionStorage.setItem('contextKitUserId', user._id)
          }
        })
      })
    },
    // -------------------
    // set jwtToken after the user is logged in
    //--------------------
    SET_JWT_TOKEN: (state, payload) => {
      if (typeof payload.token !== 'undefined') {
        state.jwtToken = payload.jwtToken
      }
    },
    // -------------------
    // Delete the user and also set jwt token to null
    //--------------------
    DELETE_USER: state => {
      state.userData = {
        id: null,
        name: null,
        email: null,
        phoneNumber: null,
        kitUsers: [],
      }
      state.contextKitUserId = null
      sessionStorage.removeItem('contextKitUserId')
      state.contextBarcodeId = null
      sessionStorage.removeItem('contextBarcodeId')
      state.jwtToken = null
      localStorage.clear()
    },
    SET_SESSION: (state, { contextKitUserId, contextBarcodeId }) => {
      state.contextKitUserId = contextKitUserId
      state.contextBarcodeId = contextBarcodeId
    },
    DELETE_SESSION: () => {
      sessionStorage.removeItem('contextBarcodeId')
      sessionStorage.removeItem('contextKitUserId')
    },
  },
  actions: {
    SET_USER: ({ commit }, payload) => {
      commit('SET_USER', payload)
    },
    // Fetch the user data and kit users for the user id
    FETCH_USER: ({ commit, state, dispatch }) => new Promise((resolve, reject) => {
      const localStorageUserData = JSON.parse(getItem('userData'))
      // If user data does not exsits in local storage, delete the token
      if (!localStorageUserData) {
        commit('DELETE_USER')
        reject(new FetchUserError('User data not found in local storage'))
      }
      // If user data (local storage) does not contain _id, delete the token
      if (!localStorageUserData._id) {
        commit('DELETE_USER')
        reject(
          new FetchUserError('User data in local storage is missing _id'),
        )
      }
      // If user data does not exsits in vuex or if user data in vuex does not contain _id, set the user data
      if (!state.userData || !state.userData._id) {
        dispatch('SET_USER', localStorageUserData)
      }
      // Check if there is a mismatch in the localstorage user id and vuex user id, if yes delete the token
      if (state.userData._id !== localStorageUserData._id) {
        commit('DELETE_USER')
        reject(new FetchUserError('User data mismatch'))
      }
      // If all the above checks work, then get the user id
      const loggedInUserId = localStorageUserData._id
      // Fetch the details of the user and kit users for that user
      Promise.all([
        axiosIns.get(`/user/${loggedInUserId}`),
        axiosIns.get('/kitUser', {
          params: {
            queryParams: { columnFilters: { accountID: loggedInUserId } },
          },
        }),
      ])
        .then(response => {
          setItem('userData', JSON.stringify(response[0].data))
          dispatch('SET_USER', {
            ...response[0].data,
            kitUsers: response[1].data.list,
          })
          resolve(response)
        })
        .catch(err => {
          commit('DELETE_USER')
          reject(
            new FetchUserError(`ERROR FETCHING USER DATA: ${err}`, false),
          )
        })
    }),
    // Load all data from local storage into vuex
    LOAD_DATA: ({ commit, state }) => new Promise((resolve, reject) => {
      const localStorageUserData = JSON.parse(getItem('userData'))
      // If user data does not exsits in local storage, delete the token
      if (!localStorageUserData) {
        commit('DELETE_USER')
        reject(new FetchUserError('User data not found in local storage'))
      }
      // If user data (local storage) does not contain _id, delete the token
      if (!localStorageUserData._id) {
        commit('DELETE_USER')
        reject(
          new FetchUserError('User data in local storage is missing _id'),
        )
      }
      // If user data does not exsits in vuex or if user data in vuex does not contain _id, set the user data
      if (!state.userData || !state.userData._id) {
        dispatch('SET_USER', localStorageUserData)
      }
      // Check if there is a mismatch in the localstorage user id and vuex user id, if yes delete the token
      if (state.userData._id !== localStorageUserData._id) {
        commit('DELETE_USER')
        reject(new FetchUserError('User data mismatch'))
      }
      // If jwtToken is null get it from localStorage
      if (!state.jwtToken) {
        const localStorageJwtToken = getItem('jwtToken')
        // If JWT token is missing from local storage then delete the token in vuex
        if (!localStorageJwtToken) {
          commit('DELETE_USER')
          reject(new FetchUserError('JWT token missing from local storage'))
        }
        commit('SET_JWT_TOKEN', localStorageJwtToken)
      }
      resolve()
    }),
    LOGOUT_USER: ({ commit }) => new Promise((resolve, reject) => {
      axiosIns
        .delete('/user/logout')
        .then(() => {
          commit('DELETE_USER')
          localStorage.clear()
          resolve()
        })
        .catch(reject)
    }),
    FETCH_USER_BY_ID: ({ commit, dispatch }, userId) => new Promise((resolve, reject) => {
      // Fetch the details of the user and kit users for given user id
      Promise.all([
        axiosIns.get(`/user/${userId}`),
        axiosIns.get('/kitUser', {
          params: {
            queryParams: { columnFilters: { accountID: userId } },
          },
        }),
      ])
        .then(response => {
          setItem('userData', JSON.stringify(response[0].data))
          dispatch('SET_USER', {
            ...response[0].data,
            kitUsers: response[1].data.list,
          })
          resolve({
            ...response[0].data,
            kitUsers: response[1].data.list,
          })
        })
        .catch(err => {
          commit('DELETE_USER')
          reject(
            new FetchUserError(`ERROR FETCHING USER DATA: ${err}`, false),
          )
        })
    }),
  },
}
